


// Generated from io.spcfy.iv3.database.entities.enums.TargetRegion

export type TargetRegionKey =
  "CENTRAL_EUROPE" |
  "CHINA" |
  "NORTH_AMERICA" |
  "OCEANIA" |
  "SOUTH_AMERICA" |
  "WORLDWIDE";


export interface TargetRegionDTO {
  key: TargetRegionKey;
  label: string;    
}


export const TargetRegions: Record<TargetRegionKey, TargetRegionDTO> = {
  CENTRAL_EUROPE: { key: "CENTRAL_EUROPE", label: "Central Europe" },
  CHINA: { key: "CHINA", label: "China" },
  NORTH_AMERICA: { key: "NORTH_AMERICA", label: "North America" },
  OCEANIA: { key: "OCEANIA", label: "Oceania" },
  SOUTH_AMERICA: { key: "SOUTH_AMERICA", label: "South America" },
  WORLDWIDE: { key: "WORLDWIDE", label: "Worldwide" }
};
